import type { IconButtonProps } from '@mui/material'
import { IconButton, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import EditIcon from '@mui/icons-material/Edit'
import { memo, type ReactNode } from 'react'

type Props = IconButtonProps & {
  tooltip?: ReactNode
}

const EditIconButton = ({ tooltip, ...props }: Props) => {
  const { t } = useTranslation()
  return (
    <Tooltip title={tooltip || t('common.edit')}>
      <IconButton {...props}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  )
}

export default memo(EditIconButton)
